const routeConstant = {
  LOGIN: '/admin/login',
  DASH_BOARD: '/dashboard',
  FULL_TREE: '/full',
  USER_MANAGEMENT: '/user-management',
  GUIDE: '/guide',
  NOTFOUND: '/404',
  EMAIL_NOTIFICATION: '/email-notification',
  PRIVACY_STATEMENT: '/pages/privacy-statement',
  TERM_OF_USE: '/pages/term-of-use',
  CONTACT: '/pages/contact',
  INTRODUCTION: '/pages/about-us',
  UNAUTHORIZED: '/unauthorized',
};
export const userManagementRoute = {
  ROLE_PERMISSIONS: '/role-permissions',
  USER_LIST: '/user-list',
  DETAIL: '/detail/:id',
};

export const forgotPassRoute = {
  USER_NAME_FORGOT_PASS: '/username-forgot-password',
  CHANGE_PASS: '/change-password',
  CHANGE_PASS_SUCESS: '/change-password-success',
};

export const emailNotiRoute = {
  DETAIL: '/detail-:id',
  EDIT: '/edit-:id',
};

export default routeConstant;
